module.exports = __webpack_public_path__ + "img/edit_ticket.3dbe5819.png";